import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

/* this cell is specifically built for myDownloads table */
export const renderLatestAvailableSoftwareVersion = ({
    item,
    columnKey,
    schemaItem,
    translate,
}: TableCellProps) => (
    <td class={schemaItem.className} data-testid={columnKey}>
        {item[columnKey].version}
        {item[columnKey].hasUpdates ? (
            <span class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-text-link--green ux-u-ml-xxs">
                {schemaItem.labels?.update || translate(`${columnKey}.update`)}
            </span>
        ) : (
            ""
        )}
    </td>
);
